"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
class Message {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created Message object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.Message = Message;
//# sourceMappingURL=Message.js.map